<script>
import { mapGetters } from "vuex";
import axios from "axios";
import NOMBRES_TRANSPORTE from "../../constants/NombresTransporte";

export default {
  props: {
    submit: Function,
    form: Object,
    listaUsuarios: Object,
    clientes: Array,    
    listaTipoImportacion: Array,
    listaTipoExportacion: Array,
    usuarios: Function,
    valorGrande: Function,
    listaAduanas: Array,
    listaMediosTransporte: Array,
    medioTransporte: Function,
  },
  data() {
    return {
      limite: false,
      listaExportacion: [],
      listaImportacion: [],
      listaClientes: [],      
      AutoIncr: false,
      disabledAI: false,
      newOrDat: "nuevo",
      NOMBRES_TRANSPORTE,
    };
  },
  computed: {
    ...mapGetters({
      permission: "auth/permission",
    }),
  },
  mounted() {
    this.getUltimoDespacho();
    this.listaExportacion = [];
    this.listaTipoExportacion.forEach((el) => {
      this.listaExportacion.push({ id: el.id, text: el.tipo_operacion });
    });

    this.listaImportacion = [];
    this.listaTipoImportacion.forEach((el) => {
      this.listaImportacion.push({ id: el.id, text: el.tipo_operacion });
    });
    this.listaClientes = [];
    this.clientes.forEach((el) => {
      //console.log(el);
      this.listaClientes.push({ id: el.id, text: el.nombre });
    });
    
    this.setValueCodigo();
    this.form.autoincremental = this.AutoIncr;

  },
  methods: {
    setValueCodigo() {
      if (this.ultimo >= 485000) {
        this.form.codigo = this.ultimo + 1;
        this.AutoIncr = true;
        this.disabledAI = true;
        this.limitLength();
      }
    },

    async getUltimoDespacho() {
      await axios
        .get("api/admin/despachos/last")
        .then((resp) => {
          //console.log(resp.data.ultimo);
          this.ultimo = resp.data.ultimo?.codigo;
          if (!this.ultimo) {
            this.ultimo = 484999;
          }
        })
        .catch((err) => console.log(err));
    },

    limitLength() {
      if (this.form.codigo.length === 0) {
        return null;
      }
      //si codigos son iguales true
      if (
        this.form.codigo == this.ultimo ||
        this.form.codigo == this.ultimo + 1
      ) {
        return true;
      } else if (this.form.codigo.length === 6) {
        return true;
      }

      return false;
    },

    limitHand() {
      if (this.form.codigo >= 485000 && this.AutoIncr) {
        return true;
      }
      if (this.form.codigo >= 485000 && !this.AutoIncr) {
        //si es mayor a...  y es distinto de los valores de ultimo o +1
        return false;
      }
    },

    limitUltimo() {
      if (this.form.codigo >= 485000) {
        return true;
      }
      return false;
    },

    heredarDespacho(newOrDat) {
      //console.log(newOrDat);
      if (newOrDat == "nuevo") {
        this.form.padre_id = "";
      } else {
        this.form.ref_cliente = "";
        this.form.cod_agente = "";
        this.form.tipo_despacho = "";
        this.form.pedidor_id = "";
        this.form.jefe_operaciones_id = "";
        this.form.jefe_facturacion_id = "";
        this.form.tramitador_aduanero_id = "";
        this.form.pedidor_id = "";
        this.form.presentador_id = "";
        this.form.aduana_id = "";
        this.form.nombre_transporte = "";
        this.form.nombre_nave = "";
      }
    },

    myChangeEvent(val) {
      console.log(val);
    },
    mySelectEvent({ id, text }) {
      console.log({ id, text });
    },
    cancelar() {
      this.$router.push({ name: "Despachos" });
    },
  },
  watch: {
    ultimo(newValue, oldValue) {
      if (this.ultimo >= 485000) {
        this.AutoIncr = true;
        this.form.autoincremental = this.AutoIncr;
        this.form.codigo = parseInt(this.ultimo + 1);
      }
    },

    AutoIncr(newValue, oldValue) {
      this.form.autoincremental = this.AutoIncr;
      this.getUltimoDespacho();
      this.form.codigo = parseInt(this.ultimo + 1);
    },
  },
};
</script>

<template>
  <div class="grid grid-cols-1 place-items-center">
  
  <b-form class="flex flex-col gap-4 sm:w-1/2" @submit.prevent="submit">

    <div class="text-left">
      <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:justify-between ">
    
          <label for="codigo-input my-auto" class="text-nowrap">N° Despacho </label>
        
      </div>

        <div class="flex flex-row gap-2 justify-between items-center">
        <div class="flex flex-row items-center gap-2">
          <div class="flex flex-row items-center">
            <input          
                type="checkbox"
                class="my-auto"
                id="checkbox"
                :disabled="disabledAI"
                v-model="AutoIncr"
              />
          </div>
          <label el class="my-auto" for="checkbox">Auto Incremental</label>          
        </div>


          <div class="sm:w-42">
          <input
            :state="limitLength() && limitHand()"
            type="number"
            id="codigo-input"
            v-model="form.codigo"
            :disabled="AutoIncr"
            :change="limitLength()"
            min="0"
            max="485000"
            class="text-right my-auto"
            @keydown="valorGrande($event)"
            required
          />
          </div>
        </div>
      
        <div class="text-left">
          <div v-if="form.codigo.length !== 0">
            <span class="error" v-if="!limitLength() && !AutoIncr"
              >El número de despacho debe ser de 6 digitos de largo</span
            >
          </div>
          <div v-if="form.codigo >= 485000">
            <span class="error" v-if="!limitHand()"
              >El número de despacho debe ser menor que 485000</span
            >
          </div>
          <span class="error" id="codigo"></span>
        </div>
      
    </div>
  
    <b-form-group
      class="text-left"
      label="Despacho Nuevo/DAP"
      label-for="nuevo_dat_despacho-select"
    >
      <select
        class=""
        id="nuevo_dat_despacho-select"
        v-model="newOrDat"
        required
        @change="heredarDespacho(newOrDat)"
      >
        <option value="" disabled>Seleccione tipo de despacho</option>
        <option value="nuevo" selected>Nuevo despacho</option>
        <option value="dap">DAP o parcial</option>
      </select>
    </b-form-group>
  
  
    <b-form-group
      v-if="newOrDat == 'dap'"
      class="text-left"
      label="Despachos"
      label-for="despachos-select"
    >
      <input
        type="number"
        id="codigo_despacho"
        v-model="form.padre"
        placeholder="Ingrese un código de despacho"
      >
      </input>
 
    </b-form-group>
    
    <b-form-group v-if="newOrDat == 'nuevo'">
      
        <div cols="4">
          <b-form-group
            class="text-left"
            label="Referencia Cliente"
            label-for="ref_cliente-input"
          >
            <input
              type="text"
              id="ref_cliente-input"
              v-model="form.ref_cliente"
              v-validate.immediate="'required_if:form.padre_id,null'"
            >
            </input>
            <div class="text-left">
              <span class="error" id="ref_cliente"></span>
            </div>
          </b-form-group>
        </div>
      
      
        <div cols="4">
          <b-form-group
            v-if="listaUsuarios"
            class="text-left"
            label="Cliente"
            label-for="cliente-select"
          >
            <Select2
              class="mi-select2"
              v-model="form.clientes_id"
              :options="listaClientes"
              :settings="{
                noResults: 'es',
                placeholder: 'Seleccione un Cliente',
                width: '100%',
                multiple: false,
              }"
            />
          </b-form-group>
        </div>
    
      
        <div cols="4">
          <b-form-group
            v-if="listaUsuarios"
            class="text-left"
            label="Cod. Agente"
            label-for="cod_agente-select"
          >
            <!--

            TODO : Refactor this, use a endpoint for fetching the agents.

            -->
            <select
              id="cod_agente-select"
              class=""
              v-model="form.cod_agente"
              v-validate.immediate="'required_if:form.padre_id,null'"
            >
              <option value="" disabled>Seleccione un Cod. Agente</option>
              <option value="G-02 Juan León Valenzuela">
                G-02 Juan León Valenzuela
              </option>
              <option value="C-25 Andrés León Cabrera">
                C-25 Andrés León Cabrera
              </option>
              <option value="C-74 Pablo León Cabrera">
                C-74 Pablo León Cabrera
              </option>
            </select>
          </b-form-group>
        </div>
      
      
        <div cols="4">
          <b-form-group
            v-if="listaUsuarios"
            class="text-left"
            label="Vistos Buenos (CDA)"
            label-for="tramitador_servicio-select"
          >
            <b-form-checkbox
              id="checkbox-vistos_buenos"
              v-model="form.requiere_vistos_buenos"
              name="vistos_buenos"
              :value="true"
            >
              Requiere Documento Vistos Buenos (CDA)
            </b-form-checkbox>
          </b-form-group>
        </div>
        <div cols="4" v-if="form.requiere_vistos_buenos">
          <b-form-group
            v-if="listaUsuarios"
            class="text-left"
            label="Tramitador de servicio"
            label-for="tramitador_servicio-select"
          >
            <select
              id="tramitador_servicio-select"
              class=""
              v-model="form.tramitador_servicios_id"
            >
              <option value="" disabled>
                Seleccione un Tramitador de Servicio
              </option>
              <option
                v-for="(
                  usuario, index
                ) in listaUsuarios.listaTramitadorServicio"
                :key="index"
                :value="usuario.id"
              >
                {{ usuario.name }}
              </option>
            </select>
          </b-form-group>
        </div>
      
      <div cols="4">
          <b-form-group
            class="text-left"
            label="Aduana"
            label-for="aduana-select"
          >
            <select
              class=""
              id="aduana-select"
              v-model="form.aduana_id"
              v-validate.immediate="'required_if:form.padre_id,null'"
            >
              <option value="" disabled>Seleccione una aduana</option>
              <option v-for="(aduana, index) in listaAduanas"
              :key="index"
              :value="aduana.key"
              >
                {{ aduana.value }}
              </option>
            </select>
          </b-form-group>
        </div>
        <div cols="4">
          <b-form-group
            class="text-left"
            label="Medio de Transporte"
            label-for="transporte-select"
          >
            <select
              class=""
              id="transporte-select"
              v-model="form.nombre_transporte"
              v-validate.immediate="'required_if:form.padre_id,null'"
              @change="medioTransporte()"
            >
              <option value="" disabled>Seleccione el medio de transporte</option>
              <option v-for="(transporte, index) in listaMediosTransporte"
              :key="index"
              :value="transporte"
              >
                {{ transporte }}
              </option>
            </select>
          </b-form-group>
          <div class="text-left">
              <span class="error" id="transporte"></span>
            </div>
        </div>
        <div cols="4" v-if="form.nombre_transporte == NOMBRES_TRANSPORTE.MARITIMO">
          <b-form-group
            class="text-left"
            label="Nombre nave"
            label-for="nombre_nave-select"
          >
             <input
              type="text"
              id="nombre_nave-input"
              v-model="form.nombre_nave"
              v-validate.immediate="'required_if:form.padre_id,null'"
            >
            </input>
            <div class="text-left">
              <span class="error" id="nombre_nave"></span>
            </div>
          </b-form-group>
        </div>
        <div cols="4">
          <b-form-group
            class="text-left"
            label="Tipo de Despacho"
            label-for="tipo_despacho-select"
          >
            <select
              class=""
              id="tipo_despacho-select"
              v-model="form.tipo_despacho"
              v-validate.immediate="'required_if:form.padre_id,null'"
              @change="usuarios()"
            >
              <option value="" disabled>Seleccione el Tipo de Despacho</option>
              <option v-permisos="'gestor.view'" value="importacion">
                Importación
              </option>
              <option
                v-permisos="'pedidor_exportaciones.view'"
                value="exportacion"
              >
                Exportación
              </option>
            </select>
          </b-form-group>
        </div>
      
      <div v-if="form.tipo_despacho == 'importacion'">
        <div cols="4">
          <b-form-group
            v-if="listaUsuarios"
            class="text-left"
            label="Pedidor"
            label-for="pedidor-select"
          >
            <select
              id="pedidor-select"
              class=""
              v-model="form.pedidor_id"
              v-validate.immediate="'required_if:form.padre_id,null'"
            >
              <option value="" disabled>Seleccione un Pedidor</option>
              <option
                v-for="(usuario, index) in listaUsuarios.listaPedidor"
                :key="index"
                :value="usuario.id"
              >
                {{ usuario.name }}
              </option>
            </select>
          </b-form-group>
        </div>

        <div cols="4">
          <b-form-group
            v-if="listaUsuarios"
            class="text-left"
            label="Jefe de Operaciones"
            label-for="jefe_operaciones-select"
          >
            <select
              class=""
              id="jefe_operaciones-select"
              v-model="form.jefe_operaciones_id"
              v-validate.immediate="'required_if:form.padre_id,null'"
            >
              <option value="" disabled>
                Seleccione un Jefe de Operaciones
              </option>
              <option
                v-for="(usuario, index) in listaUsuarios.listaJefeOperaciones"
                :key="index"
                :value="usuario.id"
              >
                {{ usuario.name }}
              </option>
            </select>
          </b-form-group>
        </div>
        <div cols="4">
          <b-form-group
            v-if="listaUsuarios"
            class="text-left"
            label="Jefe de Facturación"
            label-for="jefe_facturacion-select"
          >
            <select
              class=""
              id="jefe_facturacion-select"
              v-model="form.jefe_facturacion_id"
              v-validate.immediate="'required_if:form.padre_id,null'"
            >
              <option value="" disabled>
                Seleccione un Jefe de Facturación
              </option>
              <option
                v-for="(usuario, index) in listaUsuarios.listaJefeFacturacion"
                :key="index"
                :value="usuario.id"
              >
                {{ usuario.name }}
              </option>
            </select>
          </b-form-group>
        </div>
      </div>
      <div v-if="form.tipo_despacho == 'exportacion'">
        <div cols="4">
          <b-form-group
            v-if="listaUsuarios"
            class="text-left"
            label="Pedidor"
            label-for="pedidor-select"
          >
            <select
              id="pedidor-select"
              class=""
              v-model="form.pedidor_id"
              v-validate.immediate="'required_if:form.padre_id,null'"
            >
              <option value="" disabled>Seleccione un Pedidor</option>
              <option
                v-for="(
                  usuario, index
                ) in listaUsuarios.listaPedidorExportacion"
                :key="index"
                :value="usuario.id"
              >
                {{ usuario.name }}
              </option>
            </select>
          </b-form-group>
        </div>
        <div cols="4">
          <b-form-group
            v-if="listaUsuarios"
            class="text-left"
            label="Jefe de Operaciones"
            label-for="jefe_operaciones-select"
          >
            <select
              class=""
              id="jefe_operaciones-select"
              v-model="form.jefe_operaciones_id"
              v-validate.immediate="'required_if:form.padre_id,null'"
            >
              <option value="" disabled>
                Seleccione un Jefe de Operaciones
              </option>
              <option
                v-for="(usuario, index) in listaUsuarios.listaJefeOperaciones"
                :key="index"
                :value="usuario.id"
              >
                {{ usuario.name }}
              </option>
            </select>
          </b-form-group>
        </div>
        <div cols="4">
          <b-form-group
            v-if="listaUsuarios"
            class="text-left"
            label="Jefe de Facturación"
            label-for="jefe_facturacion-select"
          >
            <select
              class=""
              id="jefe_facturacion-select"
              v-model="form.jefe_facturacion_id"
              v-validate.immediate="'required_if:form.padre_id,null'"
            >
              <option value="" disabled>
                Seleccione un Jefe de Facturación
              </option>
              <option
                v-for="(usuario, index) in listaUsuarios.listaJefeFacturacion"
                :key="index"
                :value="usuario.id"
              >
                {{ usuario.name }}
              </option>
            </select>
          </b-form-group>
        </div>

      </div>
    </b-form-group>
    <div class="flex flex-row items-center gap-2 justify-between">
        <button class="btn-secundario btn-large" @click="cancelar">
          Cancelar
        </button>
        <button
          class="btn-principal btn-large"
          type="submit"
          :disabled="!limitLength()"
        >
          Guardar
        </button>
    </div>
  </b-form>
</div>
</template>

